import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './utils/toastNotify.css';
import { Provider } from 'react-redux';
import store  from './reduxStore/store';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <Provider store={store}>
    <BrowserRouter>
    <App />
    <ToastContainer
          theme="light"
          position="top-right"
          autoClose={4000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss={false}
          draggable
          pauseOnHover
          limit={3}
          icon={false}
          closeButton={false}
          transition={Slide}
          toastClassName={(ctx) =>
            `justo-toast justo-toast--${ctx?.type || "default"}`
          }
          bodyClassName="justo-toast__body-wrap"
          progressClassName={(ctx) =>
            `justo-toast__progress justo-toast__progress--${ctx?.type || "default"}`
          }
          className="justo-toast-container"
        />
    </BrowserRouter>
    </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
